import type { Evaluation, Student } from '@/types/global'

type StudentSessionOwner = Pick<Student, 'student_session_id'>
type SessionEvaluation = Pick<Evaluation, 'session_id'>

/**
 * Returns the session a student is currently assigned to. Historical
 * evaluations must never be used for the student's current progress.
 */
export function getCurrentStudentSessionId(student: StudentSessionOwner | null | undefined) {
  const sessionId = student?.student_session_id?.id

  return typeof sessionId === 'number' && sessionId > 0 ? sessionId : null
}

export function isCurrentStudentSessionEvaluation(
  student: StudentSessionOwner | null | undefined,
  evaluation: SessionEvaluation
) {
  const currentSessionId = getCurrentStudentSessionId(student)

  return currentSessionId !== null && evaluation.session_id?.id === currentSessionId
}

export function filterCurrentStudentSessionEvaluations<T extends SessionEvaluation>(
  student: StudentSessionOwner | null | undefined,
  evaluations: T[] | null | undefined
): T[] {
  return (evaluations ?? []).filter((evaluation) =>
    isCurrentStudentSessionEvaluation(student, evaluation)
  )
}
